
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M235.3 22c-55.7 5.4-106.8 29.4-145.4 68.2-64.2 64.5-85.6 160.4-54.7 245.3 8.4 23 23.9 50.7 37.7 67 7.7 9.2 10.4 14.1 10.9 20 .6 7.1-.9 11.1-9 24-3.8 6-7.3 12.8-7.9 15-2.8 10.2 2.7 21.6 13.1 27.1 3.3 1.8 7.8 1.9 88 2.2 90.5.3 104.9-.2 127.5-4.3 77.2-14.3 143.7-66.8 174.9-138.1 24.1-54.9 26.5-112.3 7.3-168.9-11.5-33.7-29.7-62.6-56.1-89.1-20.2-20.2-39-33.7-63.1-45.4-21.9-10.6-45.6-17.9-69.5-21.5-12.9-1.9-41.3-2.7-53.7-1.5m35.2 88.2c6.2 3.2 12.9 10.3 15.8 16.6 3 6.6 3 18.8 0 25.4-2.8 6.2-9.6 13.4-15.8 16.6-4.4 2.4-6.2 2.7-14.5 2.7s-10.1-.3-14.5-2.7c-6.2-3.2-13-10.4-15.8-16.6-1.6-3.5-2.1-6.7-2.1-12.7 0-9.6 2.1-15 8.5-22 7.3-7.9 14-10.6 25.4-10.1 6.2.2 9.1.8 13 2.8m-8.2 100.9c4.9 1.3 10.5 6.3 12.8 11.4 1.7 3.7 1.9 8 1.9 61.2V341h3.1c5.4 0 11.6 2.1 15.3 5.2 12.1 9.9 10.1 28.4-3.7 35.3-4.9 2.4-5.9 2.5-22.4 2.5-18.9 0-22.3-.7-27.6-5.8-1.6-1.5-3.7-4.4-4.8-6.4-1.8-3.5-1.9-6.6-1.9-61.3V253h-3.1c-10.7 0-20.7-7.3-22.7-16.6-2.3-10.6 2.4-19.9 12.3-24.5 3.4-1.6 6.5-1.9 20.5-1.9 9.1 0 18.2.5 20.3 1.1"}})])
          )
        }
      }
    